// Medios de pago de un recibo de caja (mesón y tesorería): las MISMAS reglas en las dos pantallas.
// Efectivo; débito/crédito en terminal Getnet (código de autorización, cuotas); transferencia (N° de
// operación); cheque (banco, número y fecha). El backend vuelve a validar todo.
import type { MedioCaja } from '../api/contratos';

export const NOMBRE_MEDIO: Record<MedioCaja, string> = {
  EFECTIVO: 'Efectivo',
  DEBITO: 'Débito (Getnet)',
  CREDITO: 'Crédito (Getnet)',
  TRANSFERENCIA: 'Transferencia',
  CHEQUE: 'Cheque',
};

/** Dónde se pasó la tarjeta: POS Getnet del mesón o link de pago (el pago en línea del B2B llega solo). */
export type Terminal = 'GETNET' | 'LINK_PAGO';

export interface Fila {
  medio: MedioCaja;
  terminal: Terminal;
  monto: string;
  entrega: string;
  autorizacion: string;
  cuotas: string;
  banco: string;
  numero: string;
  fecha: string;
  referencia: string;
}
export const filaNueva = (monto: string, medio: MedioCaja = 'EFECTIVO'): Fila => ({
  medio,
  terminal: 'GETNET',
  monto,
  entrega: '',
  autorizacion: '',
  cuotas: '',
  banco: '',
  numero: '',
  fecha: '',
  referencia: '',
});
/** Pesos enteros desde lo digitado («12.500» → 12500). */
export const entero = (t: string) => {
  const v = t.replace(/[.\s$]/g, '');
  return /^\d+$/.test(v) ? Number(v) : NaN;
};

export function problemaDe(f: Fila): string | null {
  const m = entero(f.monto);
  if (!(m > 0)) return 'monto en pesos';
  if ((f.medio === 'DEBITO' || f.medio === 'CREDITO') && f.autorizacion.trim().length < 3)
    return 'código de autorización del voucher';
  if (f.medio === 'CREDITO' && f.cuotas && !(Number(f.cuotas) >= 1 && Number(f.cuotas) <= 48))
    return 'cuotas 1 a 48';
  if (f.medio === 'CHEQUE' && (f.banco.trim().length < 2 || !f.numero.trim() || !f.fecha))
    return 'banco, número y fecha del cheque';
  if (f.medio === 'TRANSFERENCIA' && f.referencia.trim().length < 3) return 'N° de operación';
  return null;
}

export function medioDe(f: Fila) {
  const monto = String(entero(f.monto));
  switch (f.medio) {
    case 'EFECTIVO':
      return { medio: f.medio, monto };
    case 'DEBITO':
      return { medio: f.medio, monto, terminal: f.terminal, autorizacion: f.autorizacion.trim() };
    case 'CREDITO':
      return {
        medio: f.medio,
        monto,
        terminal: f.terminal,
        autorizacion: f.autorizacion.trim(),
        ...(f.cuotas ? { cuotas: Number(f.cuotas) } : {}),
      };
    case 'TRANSFERENCIA':
      return {
        medio: f.medio,
        monto,
        referencia: f.referencia.trim(),
        ...(f.banco.trim().length >= 2 ? { banco: f.banco.trim() } : {}),
        ...(f.fecha ? { fechaDocumento: f.fecha } : {}),
      };
    case 'CHEQUE':
      return {
        medio: f.medio,
        monto,
        banco: f.banco.trim(),
        numeroDocumento: f.numero.trim(),
        fechaDocumento: f.fecha,
      };
  }
}
